import { PlayerAhoyEvent } from '../player_ahoy_event';
import { PlayerEnvironment } from '../player_environment';

export default class SqueezeFrame {
  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
    this.playerDisplayAdState = options.playerDisplayAdState;
    this._isGoogleTagDisplayCalled = false;
    this._isStarted = false;
  }

  tech() {
    return this._tech;
  }
 
  data() {
    return this._data;
  }

  get name() {
    return 'squeeze_frame'
  }

  show(options = {targetings: []}) {
    this.setWidescreenClassName();
    
    if (this._isStarted) {
      return;
    }

    if (this.shouldTriggerSqueezeFrameAd()) {
      this._isStarted = true;
      this.setTargetings(options.targetings);

      this.squeezePlayer();

      if (this._isGoogleTagDisplayCalled) {
        window.googletag.cmd.push(this.refreshAd());
      } else {
        window.googletag.cmd.push(this.displayAd());
        this._isGoogleTagDisplayCalled = true;
      }
    }
  }

  hide(shouldResetPlayerDisplayAdState = true) {
    if (!this._isStarted) return

    this._isStarted = false;
    this.restorePlayer();

    //TODO: Delete after direct calls to hide in Vidio is removed
    if (shouldResetPlayerDisplayAdState) {
      this.playerDisplayAdState.tryReset(this);
    }
  }

  //TODO: Delete after calls in Vidio is removed
  start() {
    this.playerDisplayAdState.tryShowAd(this)
  }

  isReady() {
    return this.shouldTriggerSqueezeFrameAd();
  }

  shouldTriggerSqueezeFrameAd() {
    return !!(
      this.isGPTConfigured() && 
      this.isPlayerNotInPIPMode() && 
      this.isNotMobilePortraitScreen() && 
      this.isNotMobileLandscapeNonFullscreen());
  }

  isPlayerNotInPIPMode() {
    const player = document.querySelector('#article-player');

    if (player == null) {
      return true;
    }

    return !player.classList.contains('video-pip');
  }

  isGPTConfigured() {
    return !!(
      window.googletag &&
      window.googletag.apiReady &&
      window.googletag.pubadsReady &&
      window.kmklabs &&
      window.kmklabs.gpt &&
      window.kmklabs.gpt.squeeze_frame
    );
  }

  displayAd() {
    return function() {
      window.googletag.display(window.kmklabs.gpt.squeeze_frame);
    };
  }

  refreshAd() {
    return function() {
      window.googletag.pubads().refresh([window.kmklabs.gpt.squeeze_frame]);
    };
  }

  restorePlayer() {
    const playerComponentWrapper = document.getElementById('player_component_wrapper');
    const squeezeFrameAdContainer = document.getElementById('squeezeFrameAdContainer');
    playerComponentWrapper.classList.remove('squeeze');

    if (this.isMobileLandscapeFullscreen()) {
      squeezeFrameAdContainer.style.display = 'none';
    }

    setTimeout(() => {
      squeezeFrameAdContainer.remove()
    }, 1000)
  }

  squeezePlayer() {
    this.tech().el().el().append(this.createSqueezeFrameAdContainer());

    window.googletag.pubads().addEventListener('slotOnload', (event) => {
      if(!event.isEmpty && event.slot.getSlotId().getDomId() == 'squeeze_frame') {
        document.querySelector('#player_component_wrapper').classList.add('squeeze');
      }
    });
  }

  isNotMobilePortraitScreen() {
    return !(PlayerEnvironment.isMobileSite() && !this.isScreenOnLandscape());
  }

  isNotMobileLandscapeNonFullscreen() {
    return !(PlayerEnvironment.isMobileSite() && this.isScreenOnLandscape() && !this.tech().isFullscreen());
  }

  isMobileLandscapeFullscreen() {
    return PlayerEnvironment.isMobileSite() && this.isScreenOnLandscape() && this.tech().isFullscreen();
  }

  isScreenOnLandscape() {
    return screen.height < screen.width;
  }

  createSqueezeFrameAdContainer() {
    const container = document.createElement('div');
    container.id = 'squeezeFrameAdContainer'
    container.className = 'squeeze-frame-ad-container ntc-container';

    container.appendChild(this.createSqueezeFrameAd());

    return container;
  }

  createSqueezeFrameAd() {
    const squeezeFrameAd = document.createElement('div');
    squeezeFrameAd.id = 'squeeze_frame';

    return squeezeFrameAd;
  }

  setWidescreenClassName() {
    const ratio = screen.width / screen.height;
    const vjsContainer = document.querySelector('.video-js');
    if (ratio >= 16/9) {
      vjsContainer.classList.add('widescreen');
    } else {
      vjsContainer.classList.remove('widescreen');
    }
  }

  setTargetings(targetings) {
    targetings.forEach((targeting) => {
      window.kmklabs.gpt.squeeze_frame.setTargeting(targeting.key, targeting.value);
    });
  }
}
